
import React, { useState } from 'react';
import './menu.css';
import MenuLink from './../menuLink/menuLink';
import Wallet from '../../img/Wallet (1).png';
import Bank from '../../img/Bank.png';
import GitDiff from '../../img/GitDiff.png';
import ArrowSquareIn from '../../img/ArrowSquareIn.png';
import ClockCounterClockwise from '../../img/ClockCounterClockwise.png';
import Storefront from '../../img/Storefront.png';
import Handshake from '../../img/Handshake.png';
import Question from '../../img/Question.png';
import IdentificationCard from '../../img/IdentificationCard.png';
import Sliders from '../../img/Sliders.png';
import SignOut from '../../img/SignOut.png';
import UserImg from '../../img/UserCircle.png';
import { Link } from 'react-router-dom';
import Button from './../button/button';
import prapor from '../../img/Group 1 (5).png';

const Menu = () => {
  const [isActive, setActive] = useState(false);
  return (
    <>
      <div className={
        isActive ? 'mob_menu_active ' : 'container_Menu menu_Mob '
      }>
        <div className="content_user">
          <div className="container_user">
            <img src={UserImg} alt="user_img" className="user_img" />
            USER2021
          </div>
          <div className="exite" onClick={() => setActive(!isActive)}>
            <div></div>
            <div className="pointer"></div>
          </div>
        </div>
        <Link to="/Cripto">
          <MenuLink src={Wallet} linkName="Кошельки" />
        </Link>
        <Link to="/DepositPage">
          <MenuLink src={Bank} linkName="Депозит" />
        </Link>
        <MenuLink src={GitDiff} linkName="Обмен" />
        <MenuLink src={ArrowSquareIn} linkName="Вывод" />
        <Link to="/HistoryPage">
          <MenuLink src={ClockCounterClockwise} linkName="История" href="/" />
        </Link>
        <Link to="/StoresPage">
          <MenuLink src={Storefront} linkName="Магазины" href="/" />
        </Link>
        <Link to="/AffiliatePage">
          <MenuLink src={Handshake} linkName="Партнёрская программа" />
        </Link>
        <Link to="/FAQ">
          <MenuLink src={Question} linkName="FAQ" />
        </Link>
        <MenuLink src={IdentificationCard} linkName="Контакты" />
        <MenuLink src={Sliders} linkName="Настройкиты" />
        <MenuLink src={SignOut} linkName="Выйти" />
      </div>
      <div className="conteainer_logo_content">
        <div className="burger" onClick={() => setActive(!isActive)}>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className="content_lang_logo">
          <div className="content_lang">
            <div className="name_lang">
              Рус
            </div>
            <div className="prapor">
              <img src={prapor} alt="prapor" />
            </div>
          </div>
          <Button name="Выйти" />
        </div>
      </div>
    </>

  )
}

export default Menu;